import { useState, useEffect } from "react";
import { Button, DatePicker, Form, Input, notification, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { get, post } from "../../services";

const EventForm = () => {
  const { id } = useParams(); // This will get the 'id' from the URL
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [adminData, setAdmins] = useState([]);
  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };
  let options = [];
  // Method for API call
  const getAdmins = () => {
    get(`/user/getAllUsers?page=${1}&limit=${100}`)
      .then((response) => {
        console.log(response?.data?.users);
        response?.data?.users?.forEach((item) => {
          options.push({
            value: item?._id,
            label: item?.name,
          });
        });
        setAdmins(options);
        setLoader(false);
      })
      .catch((err) => {
        // to check token if token expired then logout user
        setLoader(false);
      });
  };

  // useEffect to get content
  useEffect(() => {
    getAdmins();
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    setLoader(true);
    let payload = {
      ...values,
      dueDate: values?.dueDate?.$d,
    };
    if (id) {
      payload.listingId = id;
    }
    post(`/tasks/createTask`, payload)
      .then(() => {
        setLoader(false);
        navigate("/tasks");
        openNotification("Success", "Task Assigned Successfully");
      })
      .catch(() => {
        setLoader(false);
        openNotification("Error", "");
      });
  };

  return (
    <>
      <div className="header">
        <h3>Add Task</h3>
      </div>
      <div className="form_container">
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: "Please enter your Title" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              { required: true, message: "Please enter your description" },
            ]}
          >
            <Input type="text" />
          </Form.Item>
          <Form.Item
            className="w-full"
            name="assignedUsers"
            direction="vertical"
            label="Add Users"
            rules={[{ required: true, message: "Please select user" }]}
          >
            <Select
              name="assignedUsers"
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              placeholder="Please select"
              defaultValue={[]}
              // onChange={handleChange}
              options={adminData}
            />
          </Form.Item>
          <Form.Item
            name="dueDate"
            label="Date"
            rules={[{ required: true, message: "Please enter your Due Date" }]}
            className="w-full"
          >
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item>
            <div className="form_submit">
              <Button className="back_button" onClick={() => navigate("/")}>
                Back
              </Button>
              <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
export default EventForm;
